module.exports = __webpack_public_path__ + "static/img/paste.cdacc8f1.svg";